"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const recoil_1 = require("recoil");
const userInfoState_1 = __importDefault(require("@/common/components/NavHeader/userInfoState"));
const notificationLogFilterState_1 = __importDefault(require("@/common/components/NavHeader/NavHeaderNotification/notificationLogFilterState"));
const overlayscrollbars_react_1 = require("overlayscrollbars-react");
require("overlayscrollbars/overlayscrollbars.css");
const react_query_1 = require("@tanstack/react-query");
const react_i18next_1 = require("react-i18next");
const api_1 = require("@/api");
const useIsDataFetching_1 = __importDefault(require("@/common/functions/useIsDataFetching"));
const usePullToRefresh_1 = __importDefault(require("@/common/functions/usePullToRefresh"));
const components_1 = require("@/common/components");
const useMediaQuery_1 = __importDefault(require("@mui/material/useMediaQuery"));
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const _1 = require(".");
function default_1() {
    const { user_id } = (0, recoil_1.useRecoilValue)(userInfoState_1.default);
    const { buyerFilter, channelFilter } = (0, recoil_1.useRecoilValue)(notificationLogFilterState_1.default);
    const getFetchUrl = (nextPageUrl) => {
        if (nextPageUrl)
            return nextPageUrl;
        else {
            let queryParams = new URLSearchParams();
            buyerFilter && queryParams.append('is_buyer', '1');
            !!channelFilter && queryParams.append('filter', String(channelFilter));
            const queryParamString = String(queryParams);
            return `/api/v1/members/${user_id}/notification-log${!!queryParamString ? `?${queryParamString}` : ''}`;
        }
    };
    const notificationQueryKey = ['notificationLogData', user_id, buyerFilter, channelFilter];
    const THREE_MIN = 180000; // ms
    const { isLoading, isFetching, data, fetchNextPage, isFetchingNextPage, hasNextPage } = (0, react_query_1.useInfiniteQuery)(notificationQueryKey, ({ pageParam: nextPageUrl }) => __awaiter(this, void 0, void 0, function* () {
        const fetchUrl = getFetchUrl(nextPageUrl);
        const res = yield (0, api_1.getData)(fetchUrl);
        return res.data;
    }), {
        getNextPageParam: data => { var _a; return (_a = data.meta.next) !== null && _a !== void 0 ? _a : undefined; },
        staleTime: THREE_MIN,
        cacheTime: THREE_MIN,
        refetchOnWindowFocus: false,
    });
    (0, useIsDataFetching_1.default)(isFetching);
    const getRenderData = () => {
        if (data) {
            return data.pages.flatMap(obj => obj.result);
        }
        else {
            return [];
        }
    };
    const renderData = (0, react_1.useMemo)(getRenderData, [data]);
    const hasRenderData = Boolean(renderData.length);
    const maxWidth768 = (0, useMediaQuery_1.default)('(max-width:768px)');
    const { t } = (0, react_i18next_1.useTranslation)();
    const queryClient = (0, react_query_1.useQueryClient)();
    const refetchNotificationLogQuery = () => {
        queryClient.setQueryData(notificationQueryKey, data => data && {
            pages: data.pages.slice(0, 1),
            pageParams: data.pageParams.slice(0, 1),
        });
        queryClient.refetchQueries(notificationQueryKey);
    };
    const { isRefreshing, setRefreshDiv } = (0, usePullToRefresh_1.default)({
        refetchFn: refetchNotificationLogQuery,
        isRefetching: isFetching,
        additionalDeps: notificationQueryKey,
    });
    const additionalInfiniteScrollerCss = { height: '100px', marginTop: hasNextPage ? 0 : '-100px' };
    if (isLoading) {
        return ((0, jsx_runtime_1.jsx)("div", Object.assign({ css: { display: 'flex', justifyContent: 'center', paddingTop: '200px' } }, { children: (0, jsx_runtime_1.jsx)(CircularProgress_1.default, { size: 24, color: "secondary", thickness: 4 }) })));
    }
    if (!hasRenderData) {
        return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: "body1 gray-60", css: { paddingTop: '200px', textAlign: 'center' } }, { children: t('아직 새로운 알림이 없어요!') })));
    }
    if (maxWidth768) {
        return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ ref: setRefreshDiv, css: { width: '100%', height: 'calc(100% - 104px)', overflowY: 'auto' } }, { children: [(0, jsx_runtime_1.jsx)("div", Object.assign({ css: {
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        height: isRefreshing ? '40px' : 0,
                        transition: isRefreshing ? 'unset' : '0.3s',
                    } }, { children: isRefreshing && (0, jsx_runtime_1.jsx)(CircularProgress_1.default, { size: 20, color: "secondary", thickness: 4 }) })), (0, jsx_runtime_1.jsx)(_1.NotificationLogList, { renderData: renderData }), (0, jsx_runtime_1.jsx)(components_1.InfiniteScroller, { fetchNextPage: fetchNextPage, isFetchingNextPage: isFetchingNextPage, hasRenderData: hasRenderData, additionalCss: additionalInfiniteScrollerCss })] })));
    }
    return ((0, jsx_runtime_1.jsxs)(overlayscrollbars_react_1.OverlayScrollbarsComponent, Object.assign({ css: { width: '100%', height: 'calc(100% - 48px)' }, options: { scrollbars: { autoHide: 'scroll', autoHideDelay: 300 } }, defer: true }, { children: [(0, jsx_runtime_1.jsx)(_1.NotificationLogList, { renderData: renderData }), (0, jsx_runtime_1.jsx)(components_1.InfiniteScroller, { fetchNextPage: fetchNextPage, isFetchingNextPage: isFetchingNextPage, hasRenderData: hasRenderData, additionalCss: additionalInfiniteScrollerCss })] })));
}
exports.default = default_1;
